const profiles = {
  header: {
    btnCreate: 'Create',
  },

  toast: {
    error: {
      badResponse: '[Profile] bad server response',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
      delete: {
        body: 'Profiles were deleted successfully',
      },
    },
  },
  table: {
    headers: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  forms: {
    header: {
      createProfile: {
        title: 'Create',
      },

      updateProfile: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    general: {
      header: 'General',
      fields: {
        profileType: {
          label: 'Profile Type',
          options: {
            retail: 'Retail',
            individual: 'Individual',
            wholesale: 'Wholesale',
            corporate: 'Corporate',
            web: 'Web',
            hotel: 'Hotel',
            thirdParty: '3rd Party',
            tourOperator: 'Tour Operator',
            receiptiveOperator: 'Receiptive Operator',
          },
        },
        rateType: {
          label: 'Rate Type',
          options: {
            connections: 'Connections',
            corporate: 'Corporate Rate',
            expedia: 'Expedia',
            groundTransportation: 'Ground Transportation',
            holidayTaxis: 'Holiday Taxis',
            respectiveOperator: 'Respective Operator Rate',
            retail: 'Reatil Rate',
            tourOperator: 'Tour Operator Rate',
            viator: 'Viator',
          },
        },
        name: {
          label: 'Name',
        },
        status: {
          label: 'Status',
          options: {
            active: 'Active',
            inactive: 'Inactive',
            onHold: 'On Hold',
          },
        },
        email: {
          label: 'Email address',
        },
        startDate: {
          label: 'Start Date',
        },
        phone: {
          label: 'Phone number',
        },
        additionalPhone: {
          label: 'Additional phone',
        },
        fax: {
          label: 'Fax number',
        },
        attributes: {
          label: 'Attributes',
        },
      },
    },
    billing: {
      header: 'Billing Information',
      fields: {
        name: {
          label: 'Billing Name',
        },
        email: {
          label: 'Email Address',
        },
        phone: {
          label: 'Phone Number',
        },
        address: {
          label: 'Address',
        },
        city: {
          label: 'City',
        },
        state: {
          label: 'State',
        },
        zip: {
          label: 'Zip Code',
        },
        country: {
          label: 'Country',
          options: {
            usa: 'USA',
          },
        },
      },
    },
    notes: {
      header: 'Notes',
      fields: {
        general: {
          label: 'General',
        },
        driver: {
          label: 'Driver',
        },
        dispatch: {
          label: 'Dispatch',
        },
      },
    },
    complexNotes: {
      header: 'Notes',
      fields: {
        type: {
          label: 'Note type',
          options: {
            accident: 'Accident',
            complaint: 'Complaint',
            agentIssue: '(QC) Agent Issue',
            carIssue: '(QC) Vehicle Issue',
            noShow: 'No Show',
            general: 'General note',
            disaptch: 'Note to dispatch',
            driver: 'Note to driver',
            agent: 'Agent Note',
            cancel: 'Cancelation Note',
            booking: 'Booking Note',
          },
        },
        value: {
          label: 'Note Content',
        },
      },
      add: 'Add Note',
    },
    preferences: {
      header: 'Preferences',
      job: {
        header: 'Reservation Preferences',
        fields: {
          service: {
            label: 'Service',
          },
          sharedWith: {
            label: 'Shared With',
          },
        },
      },
      excludedDrivers: {
        header: 'Excluded Drivers',
        dualList: {
          driversList: {
            header: 'Driver List',
          },
          excludedList: {
            header: 'Excluded Drivers',
          },
        },
      },
      excludedVehicles: {
        header: 'Excluded Vehicles',
        dualList: {
          vehiclesList: {
            header: 'Vehicle List',
          },
          excludedList: {
            header: 'Excluded Vehicles',
          },
        },
      },
    },
    jobHistory: {
      header: 'Reservation History',
      lastJob: 'Last Reservation: {{lastJob}}',
      firstJob: 'First Reservation: {{firstJob}}',
    },
    contacts: {
      header: 'Contacts',
      fields: {
        name: {
          label: 'Contact Name',
        },
        type: {
          label: 'Contact Type',
          options: {
            sales: 'Salesperson',
            employee: 'Employee',
          },
        },
        email: {
          label: 'Email',
        },
        phone: {
          label: 'Phone Number',
        },
        fax: {
          label: 'Fax Number',
        },
        address: {
          label: 'Address',
        },
        city: {
          label: 'City',
        },
        state: {
          label: 'State',
        },
        zip: {
          label: 'Zip Code',
        },
        country: {
          label: 'Country',
        },
        comment: {
          label: 'Comment',
        },
      },
      add: 'Add Contact',
    },
    rules: {
      header: 'Rules',
      fields: {
        value: 'Value',
        discount: {
          label: 'Discount',
          options: {
            none: 'None',
            fixed: 'Fixed',
            fixedPP: 'Fixed Per Passenger',
            percent: 'Percent',
            percentR: 'Percent (Rounded)',
            percentRU: 'Percent (Rounded Up)',
          },
        },
        markup: {
          label: 'Markup',
          options: {
            none: 'None',
            fixed: 'Fixed',
            fixedPP: 'Fixed Per Passenger',
            percent: 'Percent',
            percentR: 'Percent (Rounded)',
            percentRU: 'Percent (Rounded Up)',
          },
        },
      },
    },
    passengers: {
      header: 'Passengers',
      found: '{{number}} passengers found',
      linkedTable: {
        title: 'Profile Passengers List',
        columns: {
          passenger: 'Passenger',
          createdAt: 'Date Created',
          vip: 'VIP',
          registerWith: 'Created at',
          reservations: 'Reservations',
        },
        actions: {
          clear: 'Clear Filter',
          remove: 'Remove Passenger',
        },
      },
      nonLinkedTable: {
        title: 'Non Linked Passengers List',
        columns: {
          passenger: 'Passenger',
          registerDate: 'Date Create',
          registerWith: 'Create at',
          profilesLinked: 'Profiles linked',
          reservations: 'Reservations',
        },
        actions: {
          clear: 'Clear Filter',
          add: 'Link Passenger',
        },
      },
    },
  },
  update: {
    success: {
      content: 'Your changes were saved successfully.',
    },
    error: {
      content: 'Could Not Save Changes.',
    },
  },
  create: {
    success: {
      content: 'Your Profile Was Created.',
    },
    error: {
      content: 'Could Not Create Profile.',
    },
  },
  delete: {
    deleteBtn: 'Delete',
    deleteModal: {
      header: 'Delete Profile?',
      body: 'You are about to delete {{number}} profiles',
    },
  },
};

export default profiles;
